<template>
  <div v-if="dnt">
    <div class="d-flex">
      <div class="field">Tipo Documento:</div>
      <div class="values">{{ getTitle() }}</div>
    </div>
    <!-- Todos los archivos -->
    <div class="d-flex">
      <div class="field">Folio:</div>
      <div class="values">{{ dnt.numero }}</div>
    </div>
    <!-- Todos los archivos -->
    <div class="d-flex">
      <div class="field">Hora y Fecha:</div>
      <div class="values">{{ dnt.fechaCreacion }}</div>
    </div>
    <div v-if="dnt.tipo === documents.project">
      <div class="field">Estado</div>
      <div class="values">
        <span v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.created">Creado</span>
        <span
          v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.rejected">
          Rechazado</span>
        <span v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.reparos">Reparos</span>
        <span v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.accepted">Aceptado</span>
        <span
          v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.pendingApproval"
        >
          Pendiente Aprobacion
        </span>
        <span v-if="dnt.estadoCodigoEstadoSistema === systemStatusCode.closed">Cerrado</span>
        <spans v-else>Desconocido</spans>
      </div>
    </div>
    <div v-if="showDeliveryDate" class="d-flex">
      <div class="field">Fecha de entrega:</div>
      <div class="values">{{ dnt.fechaEntrega }}</div>
    </div>
    <div v-if="showState" class="d-flex">
      <div class="field">Estado:</div>
      <div class="values">{{ dnt.estadoDescripcionEstadoSistema || dnt.estado }}</div>
    </div>
    <!-- Todos los archivos -->
    <div class="d-flex">
      <div class="field">Descripción:</div>
      <div class="values">{{ dnt.nombreDescriptivo }}</div>
    </div>
    <div v-if="dnt.tipo === documents.milestone" class="d-flex">
      <div class="field">Porcentaje</div>
      <div class="values">{{ dnt.porcentaje }} %</div>
    </div>
    <div v-if="showEnterpriseRut" class="d-flex">
      <div class="field">RUT Empresa:</div>
      <div class="values">
        {{ formatNumber(dnt.receptorRut.split("-")[0])}}
        -
        {{ dnt.receptorRut.split("-")[1]}}
      </div>
    </div>
    <div v-if="showSender" class="d-flex">
      <div class="field">Emisor:</div>
      <div class="values">
        {{ dnt.emisorRazonSocial }}
        {{ formatNumber(dnt.emisorRut.split('-')[0]) }}
        -
        {{ dnt.emisorRut.split('-')[1] }}
      </div>
    </div>
    <div v-if="dnt.tipo === documents.electronicMemorandum" class="d-flex">
      <div class="field">Destino</div>
      <div class="values">
        {{ info.dnt.receptorContactoNombre}} - {{ info.dnt.receptorContactoCargo}}
      </div>
    </div>
    <div v-if="showReceptor" class="d-flex">
      <div class='field'>Receptor:</div>
      <div class='values'>
        {{ dnt.receptorRazonSocial }}
        {{ formatNumber(dnt.receptorRut.split('-')[0])}}
        -
        {{ dnt.receptorRut.split('-')[1] }}</div
      >
    </div>
    <div v-if="showAmountType1 || showAmountType2 || showAmountType3" class="d-flex">
      <div class="field">Monto:</div>
      <div v-if="showAmountType1" class="values">
        {{ formatNumber(dnt.totalPrecioTotalExento) }}
        {{ dnt.totalMonedaCodigo }}
        {{ dnt.totalMonedaDescripcion }}
      </div>
      <div v-if="showAmountType2" class="values">
        {{ formatNumber(dnt.totalPrecioTotalNeto) }}
        {{ dnt.totalMonedaCodigo || 'CLP'}}
      </div>
      <div v-if="showAmountType3" class="values">
        {{ formatNumber(dnt.totalPrecioTotalNeto) }}
      </div>
    </div>
  </div>
</template>

<script>
import states from '@/febos/chile/verificarQrAprobaciones/mixins/states';

export default {
  name: 'AllTypes',
  props: ['formatNumber', 'dnt'],
  data() {
    return {
      systemStatusCode: states.systemStatusCode,
      docType: states.docType,
      documents: states.documents
    };
  },
  methods: {
    getTitle() {
      const doc = this.docType.find((dt) => dt.type === this.dnt?.tipo);
      return doc.label;
    }
  },
  computed: {
    showDeliveryDate() {
      const tipos = ['801', 'HEM', 'HES', 'LIC', 'MP', 'RD1', 'RD2'];
      return tipos.includes(this.dnt?.tipo);
    },
    showState() {
      const tipos = ['PRY', 'BTG', 'APR', '803'];
      return !tipos.includes(this.dnt?.tipo);
    },
    showSender() {
      const tipos = ['801', '803', 'ACRE', 'APR', 'BTG', 'HEM', 'HES', 'LIC', 'MEMO', 'MP', 'RD1', 'RD2'];
      return tipos.includes(this.dnt?.tipo);
    },
    showReceptor() {
      const tipos = ['801', '803', 'BTG', 'HEM', 'HES', 'LIC', 'MP', 'RD1', 'RD2'];
      return tipos.includes(this.dnt?.tipo);
    },
    showAmountType1() {
      const tipos = ['801', 'HEM', 'HES', 'LIC', 'MP'];
      return tipos.includes(this.dnt?.tipo);
    },
    showAmountType2() {
      const tipos = ['803', 'BTG', 'RD1', 'RD2'];
      return tipos.includes(this.dnt?.tipo);
    },
    showAmountType3() {
      const tipos = ['AGD', 'AGR', 'CFZ', 'CHN', 'EPG', 'GOT', 'PLZ', 'PRY', 'SCO', 'SWF'];
      return tipos.includes(this.dnt?.tipo);
    },
    showEnterpriseRut() {
      const tipos = ['AGD', 'AGR', 'CFZ', 'CHN', 'EPG', 'GOT', 'PLZ', 'PRY', 'SCO', 'SWF'];
      return tipos.includes(this.dnt?.tipo);
    },
  }
};
</script>
